import classNames from 'clsx';
import React, { type ForwardedRef, type ReactNode, forwardRef } from 'react';

import styles from './CustomMarkerSliderThumb.css';

interface CustomMarkerSliderThumbProps {
    pressed: boolean;
    value: number;
    thumbSatellite?: ReactNode;
}

export const CustomMarkerSliderThumb = forwardRef(
    ({ value, thumbSatellite, pressed }: CustomMarkerSliderThumbProps, ref: ForwardedRef<HTMLDivElement>) => {
        return (
            <div
                ref={ref}
                className={classNames(styles.thumb, { [styles.withAnimation]: !pressed })}
                style={{ left: `calc(${value * 100}% - var(--thumb-width) / 2)` }}
            >
                <div className={styles.thumbPointer} />
                {thumbSatellite}
            </div>
        );
    }
);

CustomMarkerSliderThumb.displayName = 'CustomMarkerSliderThumb';
